import { useEffect } from 'react'
import { ITextData } from 'types/media'

const fontFaceCache = new Map<string, Promise<void>>()

const ensureFontLoaded = (
  fontPostScriptName: string,
  fontPath: string
): Promise<void> => {
  const key = `${fontPostScriptName}|${fontPath}`
  const cached = fontFaceCache.get(key)
  if (cached) return cached
  const promise = (async () => {
    try {
      const face = new FontFace(fontPostScriptName, `url(${fontPath})`)
      await face.load()
      // FontFaceSet is missing from this project's lib.dom typings.
      ;(document.fonts as unknown as { add: (f: FontFace) => void }).add(face)
    } catch {
      // Font failed to load — cursor index/positioning still works against
      // the engine; only DOM hit-testing within contentEditable falls back.
    }
  })()
  fontFaceCache.set(key, promise)
  return promise
}

export const useEnsureFontLoaded = (textData: ITextData) => {
  useEffect(() => {
    void ensureFontLoaded(textData.fontPostScriptName, textData.fontPath)
  }, [textData.fontPostScriptName, textData.fontPath])
}
